import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'

import { Images } from '../../../assets'

import { Jetty, Vessel } from './dashboard-jetty.styled'
import {
  RenderTOJNew,
  _getVesselName,
  _getVesselImage,
  _renderTooltips,
  _getVesselPositions,
  _getVesselHeightBySize,
  _getVesselWidthBySize,
} from './dashboard-jetty.helper'
import TOJModal from './dashboard-toj-modal.container'

const VesselMorowali = (props) => {
  const [showModalTOJ, setShowModalTOJ] = useState(false)
  const [availableJetty, setAvailableJetty] = useState([])
  const [selectedItem, setSelectedItem] = useState()

  const appSize = useSelector((state) => state.appReducer)
  const scaleFactor = (parseInt(appSize.height) - 110 * parseInt(appSize.height)/943) / 943

  const toggleModalTOJ = () => setShowModalTOJ((prev) => !prev)

  const hadleClickItem = (item) => {
    setSelectedItem(item)
    toggleModalTOJ()
  }

  useEffect(() => {
    _setAvailableJetty()
  }, [props.dataJetty])

  const _setAvailableJetty = () => {
    let available = []
    props.dataJetty.map((dt, i) => {
      const avail = {
        position: i,
        show: dt.Detail != null && dt.Detail.length > 0,
        detail: dt.Detail ? dt.Detail.sort((a, b) => a.position - b.position) : [],
        jettyLength: dt.Length,
      }
      available.push(avail)
    })
    setAvailableJetty(available)
  }

  return (
    <div
      style={{
        right: 0,
        position: 'fixed',
        width: scaleFactor * 1918,
        height: scaleFactor * 943,
      }}
    >
    {showModalTOJ && (
      <TOJModal data={selectedItem} open={showModalTOJ} handleClose={toggleModalTOJ} />
    )}
    {availableJetty.length > 0 && availableJetty[0].show && (
      <Jetty
        id='dashboard-maps-div-jetty-1'
        rotate='90deg'
        top={_getVesselPositions(availableJetty[0].detail[0].Vessel_Size, 1).top}
        left={_getVesselPositions(availableJetty[0].detail[0].Vessel_Size, 1).left}
      >
        <Vessel
          src={Images[`${_getVesselImage(availableJetty[0].detail[0].Vessel_Size)}`]}
          width={ _getVesselWidthBySize(availableJetty[0].detail[0].Vessel_Size)}
          height={_getVesselHeightBySize(availableJetty[0].detail[0].Vessel_Size)}
          rotate={_getVesselName(availableJetty[0].detail[0].Vessel_Size) === 'Rig' ? '333deg' : '0deg'}
          data-tip
          data-for='jetty1'
        />
        {availableJetty[0].detail[0]?.Child?.length && (
          <RenderTOJNew
            handleClick={hadleClickItem}
            data={availableJetty[0].detail[0]}
            vesselSize={availableJetty[0].detail[0].Vessel_Size}
          />
        )}
        {_renderTooltips(availableJetty[0].detail[0], 'jetty1', -90)}
      </Jetty>
    )}
    {availableJetty.length > 1 && availableJetty[1].show && (
      <Jetty
        id='dashboard-maps-div-jetty-2'
        rotate='90deg'
        top={_getVesselPositions(availableJetty[1].detail[0].Vessel_Size, 2).top}
        left={_getVesselPositions(availableJetty[1].detail[0].Vessel_Size, 2).left}
      >
        <Vessel
          src={Images[`${_getVesselImage(availableJetty[1].detail[0].Vessel_Size)}`]}
          width={_getVesselWidthBySize(availableJetty[1].detail[0].Vessel_Size)}
          height={_getVesselHeightBySize(availableJetty[1].detail[0].Vessel_Size)}
          rotate={_getVesselName(availableJetty[1].detail[0].Vessel_Size) === 'Rig' ? '333deg' : '0deg'}
          data-tip
          data-for='jetty2'
        />
        {availableJetty[1].detail[0]?.Child?.length && (
          <RenderTOJNew
            handleClick={hadleClickItem}
            data={availableJetty[1].detail[0]}
            vesselSize={availableJetty[1].detail[0].Vessel_Size}
          />
        )}
        {_renderTooltips(availableJetty[1].detail[0], 'jetty2', -90)}
      </Jetty>
    )}
    {availableJetty.length > 2 && availableJetty[2].show && (
      <Jetty
        id='dashboard-maps-div-jetty-3'
        rotate='90deg'
        top={_getVesselPositions(availableJetty[2].detail[0].Vessel_Size, 3).top}
        left={_getVesselPositions(availableJetty[2].detail[0].Vessel_Size, 3).left}
      >
        <Vessel
          src={Images[`${_getVesselImage(availableJetty[2].detail[0].Vessel_Size)}`]}
          width={_getVesselWidthBySize(availableJetty[2].detail[0].Vessel_Size)}
          height={_getVesselHeightBySize(availableJetty[2].detail[0].Vessel_Size)}
          rotate={_getVesselName(availableJetty[2].detail[0].Vessel_Size) === 'Rig' ? '333deg' : '0deg'}
          data-tip
          data-for='jetty3'
        />
        {availableJetty[2].detail[0]?.Child?.length && (
          <RenderTOJNew
            handleClick={hadleClickItem}
            data={availableJetty[2].detail[0]}
            vesselSize={availableJetty[2].detail[0].Vessel_Size}
          />
        )}
        {_renderTooltips(availableJetty[2].detail[0], 'jetty3', -90)}
      </Jetty>
    )}
    {availableJetty.length > 3 && availableJetty[3].show && (
      <Jetty
        id='dashboard-maps-div-jetty-4'
        rotate='90deg'
        top={_getVesselPositions(availableJetty[3].detail[0].Vessel_Size, 4).top}
        left={_getVesselPositions(availableJetty[3].detail[0].Vessel_Size, 4).left}
      >
        <Vessel
          src={Images[`${_getVesselImage(availableJetty[3].detail[0].Vessel_Size)}`]}
          width={_getVesselWidthBySize(availableJetty[3].detail[0].Vessel_Size)}
          height={_getVesselHeightBySize(availableJetty[3].detail[0].Vessel_Size)}
          rotate={_getVesselName(availableJetty[3].detail[0].Vessel_Size) === 'Rig' ? '333deg' : '0deg'}
          data-tip
          data-for='jetty4'
        />
        {availableJetty[3].detail[0]?.Child?.length && (
          <RenderTOJNew
            handleClick={hadleClickItem}
            data={availableJetty[3].detail[0]}
            vesselSize={availableJetty[3].detail[0].Vessel_Size}
          />
        )}
        {_renderTooltips(availableJetty[3].detail[0], 'jetty4', -90)}
      </Jetty>
    )}
    {availableJetty.length > 4 && availableJetty[4].show && (
      <Jetty
        id='dashboard-maps-div-jetty-5'
        rotate='90deg'
        top={_getVesselPositions(availableJetty[4].detail[0].Vessel_Size, 5).top}
        left={_getVesselPositions(availableJetty[4].detail[0].Vessel_Size, 5).left}
      >
        <Vessel
          src={Images[`${_getVesselImage(availableJetty[4].detail[0].Vessel_Size)}`]}
          width={_getVesselWidthBySize(availableJetty[4].detail[0].Vessel_Size)}
          height={_getVesselHeightBySize(availableJetty[4].detail[0].Vessel_Size)}
          rotate={_getVesselName(availableJetty[4].detail[0].Vessel_Size) === 'Rig' ? '333deg' : '0deg'}
          data-tip
          data-for='jetty5'
        />
        {availableJetty[4].detail[0]?.Child?.length && (
          <RenderTOJNew
            handleClick={hadleClickItem}
            data={availableJetty[4].detail[0]}
            vesselSize={availableJetty[4].detail[0].Vessel_Size}
          />
        )}
        {_renderTooltips(availableJetty[4].detail[0], 'jetty5', -90)}
      </Jetty>
    )}
    {/* DOLPHIN */}
    {availableJetty.length > 5 && availableJetty[5].show && (
      <Jetty
        id='dashboard-maps-div-jetty-6'
        rotate='0deg'
        top={_getVesselPositions(availableJetty[5].detail[0].Vessel_Size, 6).top}
        left={_getVesselPositions(availableJetty[5].detail[0].Vessel_Size, 6).left}
      >
        <Vessel
          src={Images[`${_getVesselImage(availableJetty[5].detail[0].Vessel_Size)}`]}
          width={ _getVesselWidthBySize(availableJetty[5].detail[0].Vessel_Size)}
          height={_getVesselHeightBySize(availableJetty[5].detail[0].Vessel_Size)}
          rotate={_getVesselName(availableJetty[5].detail[0].Vessel_Size) === 'Rig' ? '333deg' : '0deg'}
          data-tip
          data-for='jetty6'
        />
        {availableJetty[5].detail[0]?.Child?.length && (
          <RenderTOJNew
            isDolphin
            handleClick={hadleClickItem}
            data={availableJetty[5].detail[0]}
            vesselSize={availableJetty[5].detail[0].Vessel_Size}
          />
        )}
        {_renderTooltips(availableJetty[5].detail[0], 'jetty6', 0)}
      </Jetty>
    )}
    </div>
  )
}

export default VesselMorowali
